const de = {
  title: 'Beiträge',
  headline: 'Überschrift',
  failedLoading: 'Beiträge konnten nicht geladen werden',
  type: {
    general: 'Allgemein',
    study: 'Studium',
    event: 'Veranstaltung',
    legal: 'Rechtliches',
    holiday: 'Freier Tag'
  },
  showMore: 'Mehr anzeigen',
  showLess: 'Weniger anzeigen',
  noEventsToday: 'Für heute sind keine Termine eingetragen',
  noArticles: 'Derzeit sind keine Beiträge vorhanden',
  viewAll: 'Alle ansehen',
  pastArticles: 'Beitragsarchiv',
  myArticles: 'Meine Beiträge',
  allDay: 'Ganztägig',
  appointmentFormat:
    '{{startTime}}{{seperator1}}{{endTime}} | {{startDate}}{{seperator2}}{{endDate}}',
  steps: {
    userGroup: 'Publikum',
    category: 'Kategorie',
    mainContent: 'Inhalt',
    lifetime: 'Lebensdauer',
    review: 'Überprüfung & Publikation'
  },
  alerts: {
    saveSuccessful: 'Der Beitrag wurde erfolgreich erstellt.',
    saveFailed: 'Der Beitrag konnte nicht erstellt werden.',
    errorLoading: 'Beitragerstellung konnte nicht geladen werden.'
  },
  tooltips: {
    articleArchive: 'Hier befinden sich alle Beiträge, deren Sichtbarkeit bereits abgelaufen ist.'
  },
  create: {
    title: 'Neuer Beitrag',
    userGroup: {
      author: 'Autorenrolle',
      recipients: 'Empfänger',
      department: 'Abteilung',
      toDivision: 'Eigenen OE:',
      toTh: 'TH-weit:',
      semester: 'Semester',
      noDepartments: 'Sie gehören keiner Abteilung an.',
      noAuthorSelected: 'Wählen Sie ein Autorenrolle aus, um mögliche Empfänger zu erhalten.',
      noRecipients: 'Diese Autorenrolle hat keine Empfänger.',
      noPossibleAuthor: 'Sie verfügen über keine Autorenrolle, die Beiträge erstellen kann.',
      changingPostAs:
        'Sie haben nicht die initiale Autorenrole! Sie verändern eventuell die Empfänger.'
    },
    general: {
      postAs: 'Posten als',
      recipients: 'Empfänger',
      selectCategory: 'Wählen Sie die Kategorie für Ihren Beitrag',
      general: 'Allgemein',
      generalDescription:
        'Erstellen Sie eine allgemeine Ankündigung, die zu keiner der anderen Kategorien passt.',
      study: 'Studium',
      studyDescription: 'Erstellen Sie eine Ankündigung zu einer Vorlesung oder einem Studiengang.',
      event: 'Veranstaltung',
      eventDescription:
        'Erstellen Sie eine neue Eventankündigung. Diese kann optional auch im Kalender eingetragen werden.',
      legal: 'Rechtliches',
      legalDescription:
        'Erstellene Sie eine wichtige Ankündigungen bezüglich Rechtsangelegenheiten',
      holiday: 'Freier Tag',
      holidayDescription: 'Erstellen Sie Ferien, Feiertag und freie Tage.'
    },
    mainContent: {
      shortDescription: 'Kurzbeschreibung',
      articleText: 'Artikeltext',
      attachements: 'Dateianhang',
      attachementUploadPlaceholder: 'Anhang hochladen (pdf, doc(x), zip, jpeg)'
    },
    lifetime: {
      venue: 'Veranstaltungsort',
      eventDate: 'Veranstaltungsdatum',
      eventDateEnd: 'Veranstaltung endet',
      eventDateDescription:
        'An welchem Tag findet das Event statt? Für diesen Tag wird ein Eintrag im Kalender erstellt, der auf diesen Beitrag verweist. Das Event kann entweder als ganztägig markiert oder für einen bestimmten Zeitraum eingetragen werden.',
      holidayDateDescription:
        'An welchem Tag finden Ferien statt? Für diesen Tag wird ein Eintrag im Kalender erstellt, der auf diesen Beitrag verweist. Ferientag können nur ganztägig erstellt werden.',
      wholeDay: 'Ganztägig',
      eventDuration: 'Dauer der Veranstaltung',
      lifetime: 'Beitrags-Lebensdauer',
      lifetimeDescription:
        'Bestimmen Sie hier die Lebensdauer des Beitrags. Innerhalb dieses Zeitraums wird der Beitrag allen berechtigten Empfängern angezeigt. Danach wird er ins Archiv verschoben. Wenn Sie keinen Endzeitpunkt angeben wird ein Standardwert von 14 Tagen angenommen.',
      startDate: 'Sichtbar ab',
      endDate: 'Sichtbar bis',
      lifetimeDescriptionEvent:
        'Der Beitrag wird bis einschließlich zum Tag des Events angezeigt und danach ins Archiv verschoben.',
      withAppointment: 'Kalendereintrag',
      withAppointmentDescription: 'Soll für diesen Beitrag ein Eintrag in den Kalender erfolgen?'
    },
    preview: {
      mailNotSend: 'Soll für diesen Beitrag keine E-Mailbenachrichtigung ausgelöst werden?',
      pushNotificationDescription:
        'Soll dieser Beitrag ebenfalls als Push-Benachrichtigung an mobile Geräte versendet werden?',
      mailNotSendAlert:
        'Zu diesem Beitrag wird keine E-Mail-Benachrichtigung ausgelöst. Dies ist beispielsweise sinnvoll, bei Erinnerungen, die nur heute wichtig sind oder Wartungsarbeiten die nur heute statt finden und die nicht in der Sammel E-Mail der Beitragsübersicht am nächsten Tag auftauchen sollen. Diese Einstellung kan nur bei der initialen Erstellung vorgenommen werden.',
      pushNotificationAlert:
        'Bitte beachten Sie, dass die Benachrichtigung als Zusammengefasste Sammelbenachrichtigung erfolgt und durch individuelle Einstellungen des Nutzers abgewählt sein könnte. Sollte es sich hierbei um eine dringende Benachrichtigung handeln, verwenden Sie hierfür bitte die dafür vorgesehene Notfallbenachrichtigung insofern Sie die Berechtigung hierfür besitzen.'
    },
    tooltips: {
      organizingRoles:
        'Personen mit einer der ausgewählten Rollen dürfen den Beitrag bearbeiten und die Empfänger benachrichtigen'
    }
  },
  edit: {
    title: 'Beitrag bearbeiten'
  },
  inspect: {
    title: 'Inspektion',
    reachedUsers: 'Erreichte Nutzer'
  },
  filter: {
    keyword: 'Stichwort (Titel / Kurztext)',
    articletype: 'Beitragstyp',
    startDate: 'Sichtbar ab',
    endDate: 'Sichtbar bis',
    division: 'Organisationseinheit'
  }
};
export default de;
export type ArticleTranslation = typeof de;
